import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background: #282E33;
    border-radius: 8px;
    width: 480px;
    max-width: 90%;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
    padding: 16px;
    border-bottom: 1px solid #3B444C;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ModalTitle = styled.h3`
    margin: 0;
    color: #B6C2CF;
    font-size: 16px;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: #B6C2CF;
    font-size: 20px;
    cursor: pointer;
    padding: 4px;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
    }
`;

export const ModalBody = styled.div`
    padding: 16px;
    overflow-y: auto;
    flex: 1;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 8px 12px;
    background: #22272B;
    border: 1px solid #3B444C;
    border-radius: 3px;
    color: #B6C2CF;
    font-size: 14px;
    outline: none;
    box-sizing: border-box;
    margin-bottom: 16px;

    &::placeholder {
        color: #8C9BAB;
    }

    &:focus {
        border-color: #579DFF;
    }
`;

export const SectionTitle = styled.h4`
    margin: 0 0 8px 0;
    color: #8C9BAB;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        width: 14px;
        height: 14px;
    }
`;

export const SectionContainer = styled.div`
    margin-bottom: 16px;
`;

export const ProjectItem = styled.button`
    width: 100%;
    padding: 8px 12px;
    background: ${props => props.isActive ? 'rgba(87, 157, 255, 0.2)' : 'transparent'};
    border: none;
    border-radius: 3px;
    color: #B6C2CF;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    text-align: left;

    &:hover {
        background: ${props => props.isActive ? 'rgba(87, 157, 255, 0.3)' : '#3B444C'};
    }

    svg {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
    }
`;

export const ProjectItemTitle = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ActiveIndicator = styled.span`
    margin-left: auto;
    font-size: 12px;
    color: #579DFF;
    flex-shrink: 0;
`;

export const EmptyState = styled.div`
    color: #8C9BAB;
    font-size: 14px;
    padding: 16px 0;
    text-align: center;
`;
